import { MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from "react-icons/md"
import Gallery from "../components/news/gallery"
import { PropTypes } from 'prop-types';
import { retrunAssets } from "../utils/getAssets";

const OurLatestNews = ({ events }) => {


    const title = events?.latestNewsTitle
    const styles = [
        "lg:col-span-2 lg:row-span-1  xl:col-span-2 xl:row-span-2 ",
        "lg:col-span-1 lg:row-span-1 xl:col-span-1 xl:row-span-1",
        "lg:col-span-1 lg:row-span-1 xl:col-span-1 xl:row-span-1",
        "lg:col-span-2 lg:row-span-1 xl:col-span-2 xl:row-span-1"

    ]
    const data = events?.latestNewsContent != null ? events?.latestNewsContent.map((item, index) => {
        item = item?.properties?.news?.items[0]?.content?.properties
        return {
            title: item?.title,
            img: item?.thumbnailImage != null ? retrunAssets(item?.thumbnailImage[0]?.url) : "",
            date: item?.publishedDate,
            css: styles[index],
            link: item?.source
        }
    }
    ) : []


    return (
        <div className="relative bg-white  text-black w-full p-6 md:px-32 flex flex-col items-center justify-center overflow-x-hidden">

            <div className="w-full h-full flex flex-col  items-center  gap-8 ">
                <div className="w-full flex flex-col items-center gap-6">
                    <h1 className="text-4xl font-bold">{title}</h1>
                    <span className={`uppercase flex gap-1 items-center justify-start w-fit  text-xs  font-bold text-cyan-600`}> <MdOutlineKeyboardDoubleArrowLeft /> NOVEMBER  OCTOBER  SEPTEMBER <MdOutlineKeyboardDoubleArrowRight /></span>
                </div>
                <div className="w-full  flex-col items-center relative">
                    <Gallery imgs={data}/>
                </div>
            </div>

        </div>
    )
}
OurLatestNews.propTypes = {
    events: PropTypes.object
}
export default OurLatestNews